export default __webpack_public_path__ + "static/media/kgc.a272ed24.png";